import { styled, Box } from '@mui/material';
import { MINIMIZED_FUNNEL_PREVIEW_HEIGHT } from '../../../../constants';

export const PreviewContainer = styled(Box)({
  height: MINIMIZED_FUNNEL_PREVIEW_HEIGHT,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
